<ng-template #dgrBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('discount-group.save-discount-group-first' | translate)
                : ('discount-group.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'discount-group.save-discount-group-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #dgrBlock
    [class]="'w-full'"
    [blocked]="isBlocked"
    [blockUi]="dgrBlockUi"
>
    @if (discountGroupId; as groupId) {
        <p-tabs scrollable [value]="0">
            <p-tablist>
                <p-tab [value]="0">{{ 'discount-group.product' | translate }}</p-tab>
                <p-tab [value]="1">{{ 'discount-group.product-group' | translate }}</p-tab>
                <p-tab [value]="2">{{ 'discount-group.document-line-item' | translate }}</p-tab>
            </p-tablist>

            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <app-discount-group-product-relation-widget [discountGroupId]="groupId" />
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <app-discount-group-product-group-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <app-discount-group-document-line-item-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    }
</blockable-div>
